<template>
  <div id="imgzoIndex" class="imgzoIndex">
    <cTitlePage :titleCheckData="titleCheckData"></cTitlePage>
<!-- <div id="nav-body" > -->
    <div class="nav-body" v-if="show_mobile_nav">
      <div :style="show_mobile_nav?'overflow: auto;height: 100%;font-size: 14px;justify-content: flex-start;display: flex;flex-direction: column;':''">
        <div class="nav-item-box"
                  v-bind:key="index_nav"
                  v-for="(navItem, index_nav) in navList"
                  v-bind:class="{'active-nav': index_nav==currentMenuIndex}"
                  v-bind:id="'nav-item-box' + index_nav"
                  v-on:click="change_page(navItem.menuID)">
          <div class="nav-item-title" v-bind:title="navItem.title" >
            <!-- v-on:onmouseover="showHoverSubItemPage(index_nav)" v-on:onmouseout="showHoverSubItemPage(-1)" > -->
              <div class="nav-icon-defaulte" v-bind:class="navItem.icon">
              </div>
              <div class="nav-name">
                <strong>{{navItem.title}}</strong> 
              </div>
          </div>
        </div>
      </div>
    </div>
    <div id="website-body" class="website-body">
      <homeBody v-if="currentMenuIndex==0"></homeBody>
      <news v-if="currentMenuIndex==1"></news>
      <productBody v-if="currentMenuIndex==2"></productBody>
      <solutionBody v-if="currentMenuIndex==3"></solutionBody>
      <aboutUs v-if="currentMenuIndex==4"></aboutUs>
      <joinUs v-if="currentMenuIndex==5"></joinUs>
      <contentUs v-if="currentMenuIndex==6"></contentUs>
      <download v-if="currentMenuIndex==7"></download>
    </div>
    <copyright :style="show_mobile_nav?'    position: relative;':''"></copyright>
  </div>
</template>

<script>

import 'element-ui/lib/theme-chalk/index.css'; // the theme changed version element-ui css
import "./css/website-icons.css"

import cTitlePage from "./components/website_head.vue"
import homeBody from "./home.vue"
import productBody from "./product_info.vue"
import solutionBody from "./solution.vue"
import news from "./news.vue"
import contentUs from "./content_us.vue"
import aboutUs from "./about_us.vue"
import joinUs from "./join_us.vue"
import download from "./download.vue"
import copyright from "./components/website_foot.vue"


import Element from 'element-ui'
import Vue from 'vue'
Vue.use(Element, {
  //size: Cookies.get('size') || 'medium', // set element-ui default size
})

export default {
  name: "websiteIndex",
  data() {
    return {
      navList:[{      // 导航栏数据。二维数据！
                  menuID:0,
                  title: '首页', 
                  pageName:'productInfo',
              },{menuID:1,
                  title: '行业新闻', 
                  pageName:'news',
              },{
                  menuID:2,
                  title: '产品信息', 
                  pageName:'productInfo',
              },{
                  path: '/zo_Statistics',
                  menuID:3,
                  redirect: '',
                  pageName: 'indexManageCenter',
                  title: '解决方案',
                },{
                  menuID:4,
                  title: '关于微影', 
                  pageName:'about',
                }],
      foot_navList:[{      // 导航栏数据。二维数据！
                  menuID:5,
                  title: '加入我们', 
                  pageName:'productInfo',
              },{menuID:6,
                  title: '联系我们', 
                  pageName:'news',
              },{
                  menuID:7,
                  title: '下载中心', 
                  pageName:'download',
              }],
      currentMenuIndex:0,                 // 默认激活菜单项
      titleCheckData:{
        HlogoURL:require('@/assets/logo/logo_pic-text.svg'),
        PatientName: "",
        PatientSex: "",
        recorderCount:0,
        noticeText:"出报告时间：DR检查后2小时，CT/MR检查后24小时。"
      },
      show_mobile_nav:false,   // 显示菜单
    };
  },
  created(){
    let access_page = this.$route.query.page;
    if (access_page == undefined) {
      this.$router.replace({path:'/index',query: { page: 0}});
    } else {
      this.currentMenuIndex = access_page;
    }
  },
  mounted() {
    // localStorage.removeItem('token_data');     // 清除js本地存储：localStorage
    // this.isLogin();
    this.IsMobile();
    if (this.$root.is_mobile) {
      this.navList = this.navList.concat(this.foot_navList);
    }
  },
  props:{
  },
  computed:{
  },
  methods: {
    IsMobile() {
      //判断是否手机端访问
      //let userAgentInfo = navigator.userAgent.toLowerCase();
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
      let bIsIphone = sUserAgent.match(/iphone os/i) == 'iphone os';
      let bIsMidp = sUserAgent.match(/midp/i) == 'midp';
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
      let bIsUc = sUserAgent.match(/ucweb/i) == 'web';
      let bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
      let bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
      let bIsAndroid = sUserAgent.match(/android/i) == 'android';
      let userAgent ="";
      //alert(sUserAgent); 
      //iphone:mozilla/5.0 (iphone; cpu iphone os 11_0 like mac os x) applewebkit/604.1.38 (khtml, like gecko) version/11.0 mobile/15a372 safari/604.1
      //galaxy:mozilla/5.0 (linux; android 5.0; sm-g900p build/lrx21t) applewebkit/537.36 (khtml, like gecko) chrome/79.0.3945.88 mobile safari/537.36
      //ipad: mozilla/5.0 (ipad; cpu os 11_0 like mac os x) applewebkit/604.1.34 (khtml, like gecko) version/11.0 mobile/15a5341f safari/604.1
      //Pixel2: mozilla/5.0 (linux; android 8.0; pixel 2 build/opd3.170816.012) applewebkit/537.36 (khtml, like gecko) chrome/79.0.3945.88 mobile safari/537.36 
      if( bIsIphone || bIsMidp || bIsUc7 || bIsUc || bIsCE || bIsWM || bIsAndroid || bIsIpad){
        this.$root.is_mobile= true;
        console.log(this.$root.is_mobile)
      }
    },
    change_page(index) {
      this.currentMenuIndex = index;
      this.show_mobile_nav = false;
    },
  },
  components: {
    copyright,
    cTitlePage,
    homeBody,
    productBody,
    solutionBody,
    news,
    aboutUs,
    contentUs,
    joinUs,
    download
  }
};
</script>


<style>
.imgzoIndex {
  /* position: relative; */
  width: 100%;
  height: 100vh;   /* H5浏览器需要100%，但报告页面在PC端100% 背景显示不好 */
  margin: auto;
  background-color:var(--SecondColor-10);
  overflow: hidden;
  
    text-align: center;
  --pcHeadHeight:48px;  /* 题头高度 */
}

/* 设置滚动条样式 */
.imgzoIndex ::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px; /*对应竖滚动条的尺寸*/
        height: 4px;/*对应横滚动条的尺寸*/
    }
.imgzoIndex ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 2px;
         -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.1);
        background: var(--SecondColor-3);
    }
.imgzoIndex ::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        border-radius: 2px;
        background: var(--SecondColor-10);
}

.imgzoIndex .nav-body-mobile{
  width: 100%;
  height: calc(100% - var(--pcDoctorHeadHeight));
  position: absolute;
  background:none;
  z-index: 99;
  overflow: auto;
}
.imgzoIndex .nav-body {
  width: 100%;
  height: calc(100% - var(--pcHeadHeight) - 16px);
  background: var(--SecondColor-30);
  color: var(--WhiteColor-2);
}
/* 设置滚动条样式 */
.imgzoIndex .nav-body::-webkit-scrollbar {
  width: 0px;
} 
.imgzoIndex .nav-body .nav-item-box {
  position: relative;  /* !!!重要   !!!important */  /* sub-manu-body 子菜单需要依赖父元素 */
    /* height: 100%; */
    width: auto;       /*  study 标题 宽度 */
    line-height:  var(--pcDoctorHeadHeight);
    padding: 0px;
    /* background-color: var(--SecondColor-1); */
}
 .imgzoIndex .nav-body .nav-item-box .nav-item-title{
    width: 100%;
    height: 48px;
    line-height: 40px;
    border-bottom: 1px solid var(--PrimaryColor-7);
    background-color: var(--PrimaryColor);
    /* color: var(--BlackColor-2); */
    display: flex;
    flex-direction: row;
    padding: 0px 8px;
    box-sizing: border-box;
    align-items: center;
}
 .imgzoIndex .nav-body .nav-item-box .nav-item-title .nav-icon-defaulte {
    height: 100%;
    width: 32px;
    background-size: 16px 16px;
}
 .imgzoIndex .nav-body .nav-item-box .nav-item-title .nav-icon-mini {
    height: 100%;
    width: 16px;
    background-size: 16px 16px;
}

 .imgzoIndex .nav-body .active-nav {
    /* background-color: var(--PrimaryColor-9);
    color: var(--PrimaryColor-1); */
    background-color: var(--PrimaryColor-10);
    /* border-bottom: 2px solid var(--PrimaryColor-9);
    box-sizing: border-box; */
} 
.imgzoIndex .nav-body .active-nav .nav-item-title .nav-name {
    color: var(--WhiteColor-1);
}
 /* .imgzoIndex .nav-body .nav-item-box .nav-item-title:hover .nav-name {
    color: var(--WhiteColor-1);
 } */
 .imgzoIndex .nav-body .nav-item-box .nav-item-title .nav-name {
    /* position: relative;
    height: 100%; 
    width: 100%;
    background-color: var(--PrimaryColor-10);
    line-height: 130%;
    font-size: calc(var(--FontSize-Base) * 120%);
    display: flex;
    align-items: center;
    flex-wrap: nowrap; */
    /*white-space: nowrap;  --是否自动换行 */
    position: relative;
    font-size: 14px;
    /* height: 100%; */
    width: 100%;
    /* background-color: var(--PrimaryColor-10); */
    display: flex;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
}
 .imgzoIndex .nav-body .nav-item-box .nav-item-title .nav-name strong{
    width: 100%;
    /* padding-left: 2px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; */
    padding-left: 6px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.mini-nav-body .nav-item-box .nav-item-title  .nav-name,
.mini-nav-body .nav-item-box .nav-item-title .nav-icon-mini {
  width: 0px;
}

.imgzoIndex .el-carousel__container {
  height: 100%;
}
.imgzoIndex .website-body {
    height: calc(100% - var(--pcHeadHeight) - var(--footPage) - 16px);
    margin-top: 8px;
}

</style>
